import React from 'react';
import { ErrorMessage, FieldProps } from 'formik';
import { memo } from 'react';
import Select from 'react-select';
import { BiErrorCircle } from 'react-icons/bi';

interface Option {
  label: string;
  value: string;
}

interface CustomSelectProps extends FieldProps {
  options: any;
  isMulti?: boolean;
  defaultValue?: any;
  className?: string;
  placeholder?: string;
  label?: string;
  onChangeCallback: any;
  editDiscount: boolean;
}

export const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    border: state?.isFocused ? '1px solid #CACFE3' : '1px solid #CACFE3',
    '&:hover': {
      border: '1px solid #CACFE3',
    },
    padding: '6px 8px',
    borderRadius: 12,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: '#16161C',
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#4062FF' : '#fff',
    color: state.isFocused ? 'white' : 'black',
    '&:hover': {
      backgroundColor: '#4062FF',
      color: 'white',
    },
  }),
};

export const DefaultSelect = ({
  className,
  placeholder,
  field,
  form,
  options,
  label,
  isMulti = false,
  onChangeCallback,
  defaultValue,
}: CustomSelectProps) => {
  // const selectOptions = options
  //   ? options?.map((item: { name: string; id: string }) => {
  //       return {
  //         label: item?.name,
  //         value: item?.id,
  //       };
  //     })
  //   : [];

  const onChange = (selectOptions: any) => {
    form.setFieldValue(
      field.name,
      isMulti
        ? (selectOptions as Option[]).map((item: Option) => item.value)
        : (selectOptions as Option).value
    );
  };
  // const getValue = () => {
  //     if (selectOptions) {
  //       if (editDiscount) {
  //         const defaultValue = getSingleDiscount?.discount?.[field.name];
  //         if (defaultValue) {
  //           return isMulti
  //             ? selectOptions.filter((option: any) =>
  //                 defaultValue.includes(option.value)
  //               )
  //             : selectOptions.find(
  //                 (option: any) => option.value === defaultValue
  //               );
  //         }
  //       }

  //       return isMulti
  //         ? selectOptions.filter(
  //             (option: any) => field.value.indexOf(option.value) >= 0
  //           )
  //         : selectOptions.find(
  //             (option: any) => option.value + '' === field.value + ''
  //           );
  //     } else {
  //       return isMulti ? [] : ('Hello' as any);
  //     }
  //   };
  return (
    <div className="mb-5">
      <label
        className={`text-text-black  text-sm mb-1 block`}
        htmlFor={field.name}
      >
        {label}
        <Select
          className={className}
          name={field.name}
          // value={getValue()}
          onChange={(newSelectOptions) => {
            onChangeCallback(newSelectOptions);
            // form.setFieldValue(
            //   field.name,
            //   isMulti
            //     ? (newSelectOptions as Option[]).map((item: Option) => item.value)
            //     : (newSelectOptions as Option).value
            // );
          }}
          styles={customStyles}
          placeholder={placeholder}
          options={options}
          defaultValue={options[defaultValue]}
          isMulti={isMulti}
          classNamePrefix="react-select"
          menuPortalTarget={document.body}
        />
      </label>
      <div className="relative">
        <BiErrorCircle size={17} color="#fff" className="absolute top-2 mx-2" />

        <ErrorMessage
          component="div"
          name={field.name}
          className=" bg-warning bg-opacity-80 text-pure-white mt-1 text-xs inline-block px-7 py-1 rounded-sm"
        />
      </div>
    </div>
  );
};

export default memo(DefaultSelect);
